import { render, staticRenderFns } from "./rop_form.vue?vue&type=template&id=0c0f3796"
import script from "./rop_form.vue?vue&type=script&lang=js"
export * from "./rop_form.vue?vue&type=script&lang=js"
import style0 from "./rop_form.vue?vue&type=style&index=0&id=0c0f3796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports